module.exports = __webpack_public_path__ + "static/media/figure-six.954d4f3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/figure-six.png
// module id = 535
// module chunks = 0